import { ClockBadgeIcon } from "../../Icons";
import { Typo } from "../../Typo";

type MarketingBannerNoRebateProgramContentProps = {
  title: string;
  message: string;
};

export const MarketingBannerNoRebateProgramContent = ({
  title,
  message,
}: MarketingBannerNoRebateProgramContentProps) => (
  <div
    className="flex flex-col items-center justify-center gap-4 py-4"
    data-testid="marketing-banner-no-rebate-program"
  >
    <ClockBadgeIcon className="h-[52px] w-[52px]" />
    <div className="flex flex-col gap-2 text-center">
      <Typo type="labelSM">{title}</Typo>
      <Typo type="bodySM" textColor="text-text-secondary">
        {message}
      </Typo>
    </div>
  </div>
);
